import store from '@/store';

import { INITIALIZE_FROM_COOKIES_AC } from '@/store/auth/actions.type';

import Main from '@/modules/main/Main.vue';
import Header from '@/modules/header/Header.vue';
import Footer from '@/modules/footer/Footer.vue';
import MinhaConta from '@/modules/minha-conta/MinhaConta.vue';
import MeuPainel from '@/modules/meu-painel/MeuPainel.vue';
import Calendario from '@/modules/calendario/Calendario.vue';
import Cliente from '@/modules/cliente/Cliente.vue';
import User from '@/modules/user/User.vue';
import Agendamento from '@/modules/agendamento/Agendamento.vue';
import Tag from '@/modules/tag/ListagemTag.vue';

const beforeEnterAuth = (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    if (store.getters.tokenFromStorage) {
      store.dispatch(INITIALIZE_FROM_COOKIES_AC);
      return next();
    }
    return next('/login');
  }
  return next();
};

export default {
  path: '/',
  name: 'main',
  redirect: { name: 'main.meu-painel' },
  components: {
    default: Main,
    header: Header,
    footer: Footer,
  },
  children: [
    {
      path: 'minha-conta',
      name: 'main.minha-conta',
      components: {
        default: MinhaConta,
      },
    },
    {
      path: 'meu-painel',
      name: 'main.meu-painel',
      components: {
        default: MeuPainel,
      },
    },
    {
      path: 'calendario',
      name: 'main.calendario',
      components: {
        default: Calendario,
      },
    },
    {
      path: 'cliente',
      name: 'main.cliente',
      components: {
        default: Cliente,
      },
    },
    {
      path: 'user',
      name: 'main.user',
      components: {
        default: User,
      },
    },
    {
      path: 'tags',
      name: 'main.tags',
      components: {
        default: Tag,
      },
    },
    {
      path: 'agendamento',
      name: 'main.agendamento',
      components: {
        default: Agendamento,
      },
    },
  ],
  beforeEnter: beforeEnterAuth,
};
